// SCSS imports
// --------------------------------------------------------

import '../scss/index.scss';

// JS imports
// --------------------------------------------------------

import { themeBtnsHandler } from './dark-mode';
import { scrollToTop } from './scroll-to-top';
import { togglePlan } from './toggle-plan';
import { animateCoverImage } from './animate-cover-img';
import { initHeader } from './init-header';
import { copyToClipboard } from './copy-to-clipboard';
import { initMobileSubmenus } from './mobile-submenu';
import { initMobileMenu } from './mobile-menu';
import { initBookACallBtn } from './book-a-call';

const overlay = document.querySelector('.overlay');
let overlayTimeoutID = null;

const showOverlay = () => {
  overlay.classList.remove('close');
  overlay.classList.add('open');
  overlay.classList.add('open-anim');
};

const stopOverlayAnim = () => {
  clearTimeout(overlayTimeoutID);
  overlay.classList.remove('open');
  overlay.classList.remove('close-anim');
  overlay.classList.remove('open-anim');
};

const hideOverlay = () => {
  overlay.classList.remove('open-anim');
  overlay.classList.add('close-anim');

  overlayTimeoutID = setTimeout(() => {
    overlay.classList.add('close');
    overlay.classList.remove('open');
    overlay.classList.remove('close-anim');
  }, 300);
};

const dropdownHandler = (btnSelector, dropdownSelector) => {
  const btn = document.querySelector(`.${btnSelector}`);
  const dropdown = document.querySelector(`.${dropdownSelector}`);

  if (!btn) {
    return;
  }

  const showDropdown = () => {
    dropdown.classList.add('show');
    dropdown.classList.add('open-anim');
  };

  const stopDropdownAnim = () => {
    dropdown.classList.remove('show');
    dropdown.classList.remove('open-anim');
  };

  const hideDropdown = () => {
    dropdown.classList.remove('open-anim');
    dropdown.classList.remove('show');
  };

  btn.addEventListener('mouseenter', () => {
    stopOverlayAnim();
    stopDropdownAnim();
    showOverlay();
    showDropdown();
  });

  btn.addEventListener('mouseleave', (e) => {
    hideOverlay();
    hideDropdown();
  });

  btn.addEventListener('keydown', (e) => {
    const dropdownBtn = e.currentTarget.querySelector('button');
    const keyCode = e.code;

    if (keyCode === 'Space' || keyCode === 'Enter') {
      clearTimeout(overlayTimeoutID);
      if (dropdownBtn.getAttribute('aria-expanded') === 'true') {
        hideOverlay();
        hideDropdown();

        dropdownBtn.setAttribute('aria-expanded', 'false');
      } else {
        stopOverlayAnim();
        stopDropdownAnim();
        showOverlay();
        showDropdown();

        dropdownBtn.setAttribute('aria-expanded', 'true');
      }
    }
  });

  btn.addEventListener('focusout', (e) => {
    const currentTargetClass = '.' + e.currentTarget.className;
    const btn = e.currentTarget.querySelector('button');

    if (!e.relatedTarget.closest(currentTargetClass) || null) {
      hideOverlay();
      hideDropdown();

      btn.setAttribute('aria-expanded', 'false');
    }
  });
};

const submenuHandler = () => {
  const submenuItems = document.querySelectorAll('.nav-submenu-item');
  const current = document.querySelector('.nav-item__link--current');

  const showSubmenu = (submenu) => {
    submenu.classList.add('show');
    submenu.classList.add('open-anim');
  };
  const stopSubmenuAnim = (submenu) => {
    submenu.classList.remove('show');
    submenu.classList.remove('open-anim');
  };
  const hideSubmenu = (submenu) => {
    submenu.classList.remove('open-anim');
    submenu.classList.remove('show');
  };

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu-wrapper');

    submenuItem.addEventListener('mouseenter', (e) => {
      stopOverlayAnim();
      stopSubmenuAnim(submenu);
      showSubmenu(submenu);
      showOverlay();
      if (current) {
        current.classList.remove('nav-item__link--current');
      }
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      hideSubmenu(submenu);
      hideOverlay();
      if (current) {
        current.classList.add('nav-item__link--current');
      }
    });

    submenuItem.addEventListener('keydown', (e) => {
      const submenuBtn = e.currentTarget.querySelector('button');
      const keyCode = e.code;

      if (keyCode === 'Space' || keyCode === 'Enter') {
        clearTimeout(overlayTimeoutID);
        if (submenuBtn.getAttribute('aria-expanded') === 'true') {
          hideSubmenu(submenu);
          hideOverlay();

          submenuBtn.setAttribute('aria-expanded', 'false');
        } else {
          stopOverlayAnim();
          stopSubmenuAnim(submenu);
          showSubmenu(submenu);
          showOverlay();

          submenuBtn.setAttribute('aria-expanded', 'true');
        }
      }
    });

    submenuItem.addEventListener('focusout', (e) => {
      const currentTargetLastClass = '.' + e.currentTarget.classList[1];
      const submenuBtn = e.currentTarget.querySelector('button');

      if (!e.relatedTarget.closest(currentTargetLastClass)) {
        hideSubmenu(submenu);
        hideOverlay();

        submenuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });
};

window.addEventListener('scroll', () => {
  animateCoverImage('.cover-img-wrapper--desktop');
  animateCoverImage('.cover-img-wrapper--mobile');

  const header = document.querySelector('.header');
  const postTitle = document.querySelector(
    '.post-header__title, .page-header__img-wrapper, .page-header__title'
  );

  if (postTitle) {
    const headerRect = header.getBoundingClientRect();
    const postTitleRect = postTitle.getBoundingClientRect();

    if (headerRect.bottom > postTitleRect.top) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }
});

dropdownHandler('header__cta', 'header-dropdown--cta');
dropdownHandler('header__account', 'header-dropdown--account');

submenuHandler();

initHeader();
themeBtnsHandler();
scrollToTop();
togglePlan(document.querySelector('.membership'));
copyToClipboard();
initMobileSubmenus();
initMobileMenu();
initBookACallBtn();

const postsLayout = document.querySelector('.posts-wrapper, .cases-section');
let nextUrl = document.head.querySelector('link[rel="next"]')?.href;

const store = {
  activeTags: [],
  posts: [],
  loadMoreUrls: []
};

const loadMorePostsDefault = async (loadMoreBtn) => {
  loadMoreBtn.classList.add('loading');

  if (nextUrl) {
    try {
      const response = await fetch(nextUrl);

      if (response.ok) {
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let posts = html.querySelector('.posts-wrapper, .cases-section').innerHTML;
        const nextPageUrl = html.querySelector('link[rel="next"]')?.href;

        //Update the next page link in the document head
        if (nextPageUrl) {
          nextUrl = nextPageUrl;
        } else {
          loadMoreBtn.style.display = 'none';
        }

        postsLayout.insertAdjacentHTML('beforeend', posts);

        loadMoreBtn.classList.remove('loading');
      } else {
        console.error('Error HTTP: ' + response.status);
      }
    } catch (error) {
      console.error(error);
    }
  }
};

const checkActiveFilters = () => {
  const tags = Array.from(document.querySelectorAll('.filter .filter__tag'));
  return tags.some((tag) => tag.classList.contains('active'));
};

const loadMorePostsWithActiveFilters = async (loadMoreBtn) => {
  loadMoreBtn.classList.add('loading');

  // Iterate through each URL stored in loadMoreUrls
  for (let i = 0; i < store.loadMoreUrls.length; i++) {
    const { nextUrl } = store.loadMoreUrls[i];
    if (nextUrl) {
      try {
        // Get all post elements from the fetched HTML
        const response = await fetch(nextUrl);
        if (response.ok) {
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          let posts = Array.from(html.querySelectorAll('.posts-wrapper article'));
          const nextPageUrl = html.querySelector('link[rel="next"]')?.href; // Check for a next page URL
          if (nextPageUrl) {
            store.loadMoreUrls[i].nextUrl = nextPageUrl;
          } else {
            store.loadMoreUrls[i].nextUrl = null;
          }
          if (store.loadMoreUrls.every((urlObj) => urlObj.nextUrl === null)) {
            loadMoreBtn.style.display = 'none';
          }
          const newPosts = convertToPostsArray(posts);
          store.posts = [...store.posts, ...newPosts]; // Append new posts to the store

          renderPostsInHtml();
          loadMoreBtn.classList.remove('loading');
        } else {
          console.error('Error HTTP: ' + response.status);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};

const getPosts = async (url) => {
  const response = await fetch(url);
  if (response.ok) {
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const posts = Array.from(html.querySelectorAll('.posts-wrapper article'));
    return posts;
  } else {
    console.log(response.status);
  }
};

const clearPostStore = () => {
  store.posts.length = 0;
};

// Initializes the "load more" URLs and manages the visibility of the load more button.
const initLoadMoreUrls = () => {
  const btnLoadMore = document.querySelector('.load-more-btn');
  nextUrl = document.querySelector('link[rel="next"]')?.href;

  if (!nextUrl || !btnLoadMore) {
    return;
  }

  store.loadMoreUrls.push({
    name: window.location.pathname,
    nextUrl
  });

  if (store.loadMoreUrls.every((urlObj) => urlObj.nextUrl === null)) {
    btnLoadMore.style.display = 'none';
  } else {
    btnLoadMore.style.display = 'flex';
  }
};

const convertToPostsArray = (posts) => {
  const convertedArray = posts.map((post) => {
    const postId = post.dataset.postId;
    const postDate = new Date(post.querySelector('time').getAttribute('datetime'));

    return {
      postId,
      postDate,
      postNodeElement: post
    };
  });

  return convertedArray;
};

// Fetches the "load more" URL from the given URL
const getLoadMoreUrl = async (url) => {
  if (!url) {
    return;
  }

  const response = await fetch(url);
  if (response.ok) {
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    nextUrl = html.querySelector('link[rel="next"]')?.href;

    return nextUrl ? nextUrl : null;
  } else {
    console.error('Error HTTP: ' + response.status);
  }
};

const filterPostsByDateInStore = () => {
  store.posts.sort((a, b) => b.postDate - a.postDate);
};

const clearPostsInHtml = () => {
  let postsLayout = document.querySelector('.posts-wrapper');
  let posts = postsLayout.querySelectorAll('article');

  posts.forEach((post) => {
    post.remove();
  });
};

// Function to merge two arrays of objects without duplicates based on postId
const mergeWithoutDuplicates = (sourceArray, incomingArray) => {
  const incomingIds = new Set(incomingArray.map((item) => item.postId));

  const filteredSource = sourceArray.filter((sourceItem) => !incomingIds.has(sourceItem.postId));

  return [...filteredSource, ...incomingArray];
};

const filterPostsByActiveTags = () => {
  store.posts = store.posts.filter((post) => {
    const postTags = post.postNodeElement
      .getAttribute('data-post-tag')
      .split(',')
      .map((tag) => tag.trim());

    return store.activeTags.some((tag) => postTags.includes(tag));
  });
};

const renderPostsInHtml = () => {
  const postsWrapper = document.querySelector('.posts-wrapper');

  let newPosts = '';
  store.posts.forEach((post) => {
    newPosts += post.postNodeElement.outerHTML;
  });

  clearPostsInHtml();
  postsWrapper.insertAdjacentHTML('beforeend', newPosts);
};

export const disableAllActiveTags = () => {
  const tags = Array.from(document.querySelectorAll('.filter .filter__tag'));

  if (!tags.length) {
    return;
  }

  tags.forEach((tag) => {
    tag.classList.remove('active');
  });
};

//Initializes the filter functionality for posts, allowing users to filter posts by tags and clear selected filters.
const initFilters = () => {
  const tags = document.querySelectorAll('.filter .filter__tag');
  const filterWrapper = document.querySelector('.filter');
  const allPostsBtn = document.querySelector('.filter__all-posts[data-tag-name="all-posts"]');

  if (!tags.length) {
    return;
  }

  tags.forEach((tag) => {
    tag.addEventListener('click', async function () {
      // Get the next URL to load based on the tag filter
      const tagUrl = this.getAttribute('data-tag-filter-url');
      const tagName = this.getAttribute('data-tag-name');
      let nextUrl = await getLoadMoreUrl(tagUrl);
      const btnLoad = document.querySelector('.load-more-btn');

      if (allPostsBtn.classList.contains('active')) {
        allPostsBtn.classList.remove('active');
      }

      if (this.classList.contains('active')) {
        // Remove the tag from the active tags store
        store.activeTags = store.activeTags.filter((activeTag) => activeTag !== tagName);
        this.classList.add('loading');
        filterWrapper.classList.add('loading');

        filterPostsByActiveTags();

        store.loadMoreUrls = store.loadMoreUrls.filter((url) => !url.name.includes(tagName));
      } else {
        this.classList.add('loading');
        filterWrapper.classList.add('loading');

        store.activeTags.push(tagName);

        const posts = await getPosts(tagUrl);
        const newPosts = convertToPostsArray(posts);

        store.posts = mergeWithoutDuplicates(store.posts, newPosts);

        store.loadMoreUrls.push({
          name: this.getAttribute('data-tag-name'),
          nextUrl
        });
      }

      store.loadMoreUrls = store.loadMoreUrls.filter((url) => !url.name.includes('archive'));

      if (store.posts.length) {
        filterPostsByDateInStore();

        renderPostsInHtml();
      }

      if (!store.posts.length) {
        const posts = await getPosts(allPostsBtn.getAttribute('data-tag-filter-url'));
        store.posts = convertToPostsArray(posts);

        allPostsBtn.classList.add('active');

        renderPostsInHtml();

        initLoadMoreUrls();
        clearPostStore();
      }

      this.classList.remove('loading');
      filterWrapper.classList.remove('loading');

      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        this.classList.add('active');
      }

      if (store.loadMoreUrls.every((urlObj) => urlObj.nextUrl === null)) {
        btnLoad.style.display = 'none';
      } else {
        btnLoad.style.display = 'flex';
      }
    });
  });

  allPostsBtn.addEventListener('click', async function () {
    disableAllActiveTags();
    allPostsBtn.classList.add('active');

    const posts = await getPosts(allPostsBtn.getAttribute('data-tag-filter-url'));
    store.posts = convertToPostsArray(posts);
    filterWrapper.classList.add('loading');

    renderPostsInHtml();

    store.loadMoreUrls = [];
    initLoadMoreUrls();
    clearPostStore();

    filterWrapper.classList.remove('loading');
  });
};

const initLoadMoreBtn = () => {
  const loadMoreButton = document.querySelector('.load-more-btn');

  if (!loadMoreButton) {
    return;
  }

  loadMoreButton.addEventListener('click', async (e) => {
    e.preventDefault();

    if (checkActiveFilters()) {
      // Load more posts with active filters if they are applied
      await loadMorePostsWithActiveFilters(loadMoreButton);
    } else {
      // Load more posts without filters if no filters are active
      await loadMorePostsDefault(loadMoreButton);
    }
  });
};

initLoadMoreUrls();
initLoadMoreBtn();
initFilters();

const getFeedbacks = async (url) => {
  const response = await fetch(url);
  if (response.ok) {
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const feedback = Array.from(html.querySelectorAll('.clients-feedback__card'));
    return feedback;
  } else {
    console.log(response.status);
  }
};

const renderFeedbacks = (card, feedbacks) => {
  feedbacks.forEach((feedback) => {
    card.append(feedback);
  });
};

const setCaseFeedbacks = async () => {
  const caseCards = Array.from(document.querySelectorAll('.case-card'));

  if (!caseCards.length) {
    return;
  }

  caseCards.forEach(async (caseCard) => {
    const caseCardLink = caseCard.querySelector('.case-card__img-link').href;
    const feedbacks = await getFeedbacks(caseCardLink);

    if (feedbacks.length) {
      renderFeedbacks(caseCard, feedbacks);
    }
  });
};

setCaseFeedbacks();

const getPostPagePosts = async (url) => {
  if (!url) {
    return;
  }

  const response = await fetch(url);
  if (response.ok) {
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const nextPageUrl = html.querySelector('link[rel="next"]')?.href;
    const posts = Array.from(html.querySelectorAll('.posts-wrapper article'));

    return { nextPageUrl, posts };
  } else {
    console.log(response.status);
  }
};

const postPageLoadMore = async () => {
  const post = document.querySelector('.post');
  const loadMoreBtn = document.querySelector('.btn--post-load-more');
  const postsWrapper = document.querySelector('.posts-wrapper');
  let postPageStore = null;

  if (post) {
    postPageStore = await getPostPagePosts(window.location.origin);
    postPageStore.posts.splice(0, 2);

    if (postPageStore.posts.length) {
      loadMoreBtn.style.display = 'flex';
    }

    loadMoreBtn.addEventListener('click', async () => {
      loadMoreBtn.classList.add('loading');
      if (!postPageStore.posts.length) {
        postPageStore = await getPostPagePosts(postPageStore.nextPageUrl);
      }

      if (postPageStore.posts.length) {
        const twoPosts = postPageStore.posts.splice(0, 2);
        twoPosts.forEach((post) => postsWrapper.append(post));
      }

      if (!postPageStore.posts.length && !postPageStore.nextPageUrl) {
        loadMoreBtn.style.display = 'none';
      }
      loadMoreBtn.classList.remove('loading');
    });
  }
};

postPageLoadMore();

const formInputs = document.querySelectorAll(
  '.contact-form-input__input, .contact-form-text-area__text-area'
);

formInputs.forEach((formInput) => {
  formInput.addEventListener('change', (e) => {
    let value = e.target.value;
    if (value == '') {
      formInput.classList.remove('no-empty');
    } else {
      formInput.classList.add('no-empty');
    }
  });
});

const iframe = document.querySelector('#ghost-comments-root iframe');

if (iframe) {
  iframe.addEventListener('load', () => {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    iframeDoc.head.insertAdjacentHTML(
      'beforeend',
      `<style>

        section.dark button[data-testid="signin-button"] {
          color: inherit !important;
        }

        section[data-testid="cta-box"] h1:first-child{
          color: #000000;
        }

        section[data-testid="cta-box"] p{
          color: #606060;
        }

        section.dark section[data-testid="cta-box"] h1:first-child{
        color: #fff;
        }
        section.dark section[data-testid="cta-box"] p{
          color: #acacac;
        }

      </style>`
    );
  });
}
